module.exports = __webpack_public_path__ + "static/media/alert-big.0c934cd2.svg";